import { Component } from '@angular/core';
import { Response } from './response';

export class ErrorResponse extends Response {
    public code: number;
    public textCode: string;
    public errorId: string;
    public requestUri: string;

    constructor(incode: number, inTextCode: string = '', inMessage: string = '', inErrorId: string = '', inRequestUri: string = '') {
        super(inMessage);
        this.code = incode;
        this.textCode = inTextCode;
        this.errorId = inErrorId;
        this.requestUri = inRequestUri;
    }
}
